module.exports = __webpack_public_path__ + "img/w3_translate_light.13c58b6b.png";